/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const PostOAuthTokenDataParser = /* #__PURE__ */ parsers.object([
    ['providerId', codecString, 'provider_id'],
    ['tempId', codecString, 'temp_id'],
]);
export class PostOAuthTokenData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PostOAuthTokenDataParser.decode(input).map(res => new PostOAuthTokenData(res));
    }
    static unsafeDecode(input) {
        return PostOAuthTokenData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PostOAuthTokenDataParser.encode(data);
    }
    static schema() {
        return PostOAuthTokenDataParser.schema();
    }
}
